import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
import { ErrorContentLayout } from 'layout';
import { 
// DocumentalValidationRelatedReadData,
// useDocumentalValidationRelatedReadQueryPromise,
useDossierReadByPersonQuery, } from '@isyc-react/oc-api';
import { DocumentationDossierFields } from 'common-app/dossier.vm';
import { DossierSelector } from './dossier-selector.component';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { DocumentalValidationCode, ObjectTypeId } from '@isyc-react/types';
import { useDocumentalValidationRelatedReadQueryPromise } from 'common/api/query';
export const DossiersContainer = () => {
    var _a, _b;
    const { user } = useAuthContext();
    const [dossiers, setDossiers] = React.useState(undefined);
    const [loading, setLoading] = React.useState(true);
    const { data, error } = useDossierReadByPersonQuery({ variables: { personId: (_b = (_a = user === null || user === void 0 ? void 0 : user.person) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0 } }, DocumentationDossierFields);
    const getDocGroupValidation = useDocumentalValidationRelatedReadQueryPromise();
    const filterDossiers = React.useCallback(() => {
        if (data) {
            const promises = [];
            data.dossier_readByPerson.forEach(d => {
                promises.push(getDocGroupValidation({ relatedId: d.id, relatedObjectTypeId: ObjectTypeId.DOSSIER }));
                d.participants.forEach(p => promises.push(getDocGroupValidation({ relatedId: p.id, relatedObjectTypeId: ObjectTypeId.PARTICIPANT })));
            });
            Promise.all(promises).then(res => {
                const result = [];
                const filter = res.filter(r => {
                    return r.data.documentalValidation_read_byRelated.some(d => {
                        if (d.validation === DocumentalValidationCode.ANY) {
                            return d.pendingDocumentRequestIdList.length > 0;
                        }
                        else {
                            return d.documentalValidationLines.some(v => v.pendingDocumentRequestIdList.length > 0);
                        }
                    });
                });
                if (filter) {
                    filter.forEach(f => f.data.documentalValidation_read_byRelated.forEach(r => {
                        data.dossier_readByPerson.forEach(d => {
                            if (d.id === r.relatedId || d.participants.some(p => p.id === r.relatedId)) {
                                if (!result.includes(d)) {
                                    result.push(d);
                                }
                            }
                        });
                    }));
                }
                setDossiers(result);
            });
        }
        else {
            setDossiers(undefined);
        }
        setLoading(false);
    }, [data]);
    React.useEffect(() => {
        setLoading(true);
        filterDossiers();
    }, [data]);
    return (React.createElement(React.Fragment, null, loading || dossiers === undefined ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
            React.createElement(Spinner, { animation: 'border' })))) : (React.createElement(React.Fragment, null, dossiers ? (React.createElement(DossierSelector, { dossiers: dossiers })) : (error && (React.createElement(ErrorContentLayout, null,
        React.createElement("h1", { className: 'text-primary' }, "Erreur de dossiers"),
        React.createElement("p", null, "impossible d'obtenir les donn\u00E9es des dossiers des utilisateurs"))))))));
};
